(function () {
  'use strict';

  function kkStr(key, fallback) {
    var o = window.kkStrings || {};
    var v = o[key];
    return v != null && String(v).length ? v : fallback;
  }

  function formatMoney(cents) {
    var n = typeof cents === 'number' ? cents : parseInt(cents, 10) || 0;
    var amount = (n / 100).toFixed(2);
    var fmt = window.kkMoneyFormat || '{{amount}}';
    if (/\{\{\s*amount_no_decimals/.test(fmt)) {
      return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(n / 100)));
    }
    return fmt.replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function thumbUrl(url) {
    if (!url) return '';
    var u = url.indexOf('//') === 0 ? 'https:' + url : url;
    return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=120';
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function showToast(msg) {
    var el = document.getElementById('kk-toast');
    if (!el) return;
    el.textContent = msg;
    el.removeAttribute('hidden');
    el.classList.add('is-visible');
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () {
      el.classList.remove('is-visible');
      el.setAttribute('hidden', '');
    }, 3200);
  }

  function setDrawerOpen(open) {
    document.documentElement.classList.toggle('kk-drawer-open', open);
  }

  function openDrawer(el) {
    if (!el) return;
    el.removeAttribute('hidden');
    el.setAttribute('aria-hidden', 'false');
    el.classList.add('is-open');
    setDrawerOpen(true);
  }

  function closeDrawer(el) {
    if (!el) return;
    el.setAttribute('hidden', '');
    el.setAttribute('aria-hidden', 'true');
    el.classList.remove('is-open');
    if (!document.querySelector('.kk-drawer.is-open')) {
      setDrawerOpen(false);
    }
  }

  function syncMenuButtons(drawerId, expanded) {
    document.querySelectorAll('.js-kk-drawer-open[aria-controls="' + drawerId + '"]').forEach(function (b) {
      b.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  /* Announcement */
  var ann = document.querySelector('[data-kk-announcement]');
  if (ann) {
    try {
      if (sessionStorage.getItem('kkAnnouncementDismissed') === '1') {
        ann.parentNode.removeChild(ann);
        ann = null;
      }
    } catch (e) {}
    if (ann) {
      ann.querySelectorAll('.js-kk-announcement-close').forEach(function (btn) {
        btn.addEventListener('click', function () {
          try {
            sessionStorage.setItem('kkAnnouncementDismissed', '1');
          } catch (e) {}
          ann.parentNode.removeChild(ann);
        });
      });
    }
  }

  /* Mobile drawers */
  document.querySelectorAll('.js-kk-drawer-open').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('aria-controls');
      var drawer = id ? document.getElementById(id) : null;
      openDrawer(drawer);
      syncMenuButtons(id, true);
    });
  });

  document.querySelectorAll('.js-kk-drawer-close').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var drawer = btn.closest('.kk-drawer');
      var id = drawer && drawer.id;
      closeDrawer(drawer);
      if (id) syncMenuButtons(id, false);
    });
  });

  document.querySelectorAll('.js-kk-close-drawer').forEach(function (link) {
    link.addEventListener('click', function () {
      var drawer = link.closest('.kk-drawer');
      if (!drawer) return;
      var id = drawer.id;
      closeDrawer(drawer);
      syncMenuButtons(id, false);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.kk-drawer.is-open').forEach(function (d) {
      var id = d.id;
      closeDrawer(d);
      syncMenuButtons(id, false);
    });
  });

  /* Cart drawer */
  var cartDrawerEnabled = document.body.getAttribute('data-cart-drawer') === 'true';
  var cartDrawer = document.getElementById('kk-cart-drawer');

  function renderCartDrawer(cart) {
    var body = document.getElementById('kk-cart-drawer-body');
    var subEl = document.getElementById('kk-cart-drawer-subtotal');
    if (!body || !subEl) return;
    if (!cart || !cart.item_count) {
      body.innerHTML =
        '<p class="kk-cart-drawer-empty">' + escapeHtml(kkStr('cartDrawerEmpty', 'Your bag is empty.')) + '</p>';
      subEl.textContent = formatMoney(0);
      return;
    }
    subEl.textContent = formatMoney(cart.total_price);
    body.innerHTML = cart.items
      .map(function (item) {
        var img = item.image
          ? '<img src="' +
            escapeHtml(thumbUrl(item.image)) +
            '" alt="" class="kk-cart-drawer-line-img" width="64" height="64" loading="lazy">'
          : '<span class="kk-cart-drawer-line-fallback" aria-hidden="true">🧶</span>';
        var qty = item.quantity != null ? parseInt(item.quantity, 10) : 1;
        if (isNaN(qty) || qty < 1) qty = 1;
        var lineKey = escapeHtml(String(item.key != null ? item.key : ''));
        var linePrice = formatMoney(item.final_line_price);
        var ariaDown = escapeHtml(kkStr('cartDrawerQtyDown', 'Decrease quantity'));
        var ariaUp = escapeHtml(kkStr('cartDrawerQtyUp', 'Increase quantity'));
        var ariaGroup = escapeHtml(kkStr('cartDrawerQty', 'Quantity'));
        return (
          '<div class="kk-cart-drawer-line">' +
          img +
          '<div class="kk-cart-drawer-line-body">' +
          '<p class="kk-cart-drawer-line-title">' +
          escapeHtml(item.product_title) +
          '</p>' +
          '<p class="kk-cart-drawer-line-meta">' +
          linePrice +
          '</p></div>' +
          '<div class="kk-cart-drawer-stepper" role="group" aria-label="' +
          ariaGroup +
          '">' +
          '<button type="button" class="kk-cart-drawer-qty-btn js-kk-cart-drawer-qty" data-delta="-1" data-line-key="' +
          lineKey +
          '" data-line-qty="' +
          String(qty) +
          '" aria-label="' +
          ariaDown +
          '"><span aria-hidden="true">−</span></button>' +
          '<span class="kk-cart-drawer-qty-num" aria-live="polite">' +
          String(qty) +
          '</span>' +
          '<button type="button" class="kk-cart-drawer-qty-btn js-kk-cart-drawer-qty" data-delta="1" data-line-key="' +
          lineKey +
          '" data-line-qty="' +
          String(qty) +
          '" aria-label="' +
          ariaUp +
          '"><span aria-hidden="true">+</span></button>' +
          '</div>' +
          '</div>'
        );
      })
      .join('');
  }

  function loadCartDrawer() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(renderCartDrawer)
      .catch(function () {});
  }

  function updateCartBadges(count) {
    document.querySelectorAll('[data-kk-cart-count]').forEach(function (el) {
      el.textContent = String(count);
      if (count > 0) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
  }

  function refreshCartUi() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        updateCartBadges(cart.item_count || 0);
        if (cartDrawer && cartDrawer.classList.contains('is-open')) {
          renderCartDrawer(cart);
        }
        return cart;
      })
      .catch(function () {});
  }

  if (cartDrawerEnabled && cartDrawer) {
    document.querySelectorAll('.js-kk-cart-drawer-trigger').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        loadCartDrawer().then(function () {
          openDrawer(cartDrawer);
        });
      });
    });
    document.querySelectorAll('.js-kk-cart-drawer-close').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeDrawer(cartDrawer);
      });
    });

    cartDrawer.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-kk-cart-drawer-qty');
      if (!btn || !cartDrawer.contains(btn)) return;
      e.preventDefault();
      var key = btn.getAttribute('data-line-key');
      var delta = parseInt(btn.getAttribute('data-delta'), 10);
      var qty = parseInt(btn.getAttribute('data-line-qty'), 10);
      if (!key || (delta !== 1 && delta !== -1)) return;
      if (isNaN(qty) || qty < 1) qty = 1;
      var newQty = qty + delta;
      if (newQty < 0) newQty = 0;
      var stepper = btn.closest('.kk-cart-drawer-stepper');
      var ctrls = stepper ? stepper.querySelectorAll('.js-kk-cart-drawer-qty') : [];
      ctrls.forEach(function (b) {
        b.disabled = true;
      });
      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: key, quantity: newQty })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error((data && (data.description || data.message)) || 'error');
            return data;
          });
        })
        .then(function (updated) {
          updateCartBadges(updated.item_count || 0);
          renderCartDrawer(updated);
          var subEl = document.getElementById('kk-cart-drawer-subtotal');
          if (subEl) subEl.textContent = formatMoney(updated.total_price || 0);
        })
        .catch(function () {
          ctrls.forEach(function (b) {
            b.disabled = false;
          });
          showToast(kkStr('toastCartQtyError', 'Could not update cart'));
        });
    });
  }

  /* Collection sort */
  document.querySelectorAll('[data-kk-collection-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      sel.closest('form').submit();
    });
  });

  /* Product page */
  var productEl = document.getElementById('kk-product-json');
  var productForm = document.getElementById('kk-product-form');

  function findVariant(product, selections) {
    var opts = product.options || [];
    return (product.variants || []).find(function (v) {
      var vo = v.options || [];
      for (var i = 0; i < opts.length; i++) {
        if (String(vo[i]) !== String(selections[i])) return false;
      }
      return true;
    });
  }

  function setMainImageFromVariant(variant) {
    var wrap = document.getElementById('kk-product-main-wrap');
    if (!wrap || !variant || !variant.featured_image || !variant.featured_image.src) return;
    var src = variant.featured_image.src;
    var img = document.getElementById('kk-product-main-img');
    var alt = variant.featured_image.alt || '';
    if (!img) {
      wrap.innerHTML =
        '<img id="kk-product-main-img" src="" alt="" width="1400" height="1400" loading="lazy">';
      img = document.getElementById('kk-product-main-img');
    }
    var u = src.indexOf('//') === 0 ? 'https:' + src : src;
    var clean = u.split('?')[0];
    img.src = clean + '?width=1400';
    img.alt = alt;
    document.querySelectorAll('.kk-product-thumb').forEach(function (t) {
      t.classList.remove('is-active');
    });
  }

  if (productEl && productForm) {
    var product;
    try {
      product = JSON.parse(productEl.textContent);
    } catch (e) {
      product = null;
    }

    if (product && product.variants) {
      var optionEls = productForm.querySelectorAll('.kk-product-option');

      function currentSelections() {
        var sel = [];
        optionEls.forEach(function (el, idx) {
          sel[idx] = el.value;
        });
        return sel;
      }

      function applyVariant(variant) {
        var idInput = document.getElementById('kk-variant-id');
        var priceEl = document.getElementById('kk-product-price');
        var stickyPrice = document.getElementById('kk-atc-sticky-price');
        var submit = document.getElementById('kk-product-submit');
        var stickyBtn = document.querySelector('.js-kk-sticky-add');
        if (!variant) {
          if (submit) {
            submit.disabled = true;
            submit.textContent = kkStr('productUnavailable', 'Unavailable');
          }
          if (stickyBtn) {
            stickyBtn.disabled = true;
            stickyBtn.textContent = kkStr('productUnavailable', 'Unavailable');
          }
          return;
        }
        if (idInput) idInput.value = variant.id;
        var money = formatMoney(variant.price);
        if (priceEl) priceEl.textContent = money;
        if (stickyPrice) stickyPrice.textContent = money;
        if (variant.featured_image) {
          setMainImageFromVariant(variant);
        }
        var available = !!variant.available;
        if (submit) {
          submit.disabled = !available;
          submit.textContent = available
            ? kkStr('productAddBag', 'Add to bag')
            : kkStr('productSoldOut', 'Sold out');
        }
        if (stickyBtn) {
          stickyBtn.disabled = !available;
          stickyBtn.textContent = available
            ? kkStr('productAddBag', 'Add to bag')
            : kkStr('productSoldOut', 'Sold out');
        }

        /* Update stock warning for the selected variant */
        var stockEl = document.getElementById('kk-stock-warn');
        if (stockEl) {
          var threshold = parseInt(stockEl.getAttribute('data-threshold') || '5', 10);
          var inv = typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : null;
          var managed = variant.inventory_management && variant.inventory_management !== 'none';
          var deny = variant.inventory_policy === 'deny';
          if (managed && deny && inv !== null && inv > 0 && inv <= threshold) {
            var tpl = kkStr('stockLowMsg', 'Only COUNT left — order soon!');
            stockEl.textContent = '⚡ ' + tpl.replace('COUNT', String(inv));
            stockEl.removeAttribute('hidden');
            stockEl.style.display = '';
          } else {
            stockEl.setAttribute('hidden', '');
            stockEl.style.display = 'none';
          }
        }

        /* Update back-in-stock form visibility */
        var bisWrap = document.getElementById('kk-bis-wrap');
        if (bisWrap) {
          if (!available) {
            /* Update the body field to include the variant name */
            var bisBody = document.getElementById('kk-bis-body');
            if (bisBody && variant.title && variant.title !== 'Default Title') {
              var base = bisBody.getAttribute('data-base') || bisBody.value;
              bisBody.setAttribute('data-base', base);
              bisBody.value = 'Back-in-stock request for: ' + (product.title || '') + ' — ' + variant.title + ' — ' + (window.location.href);
            }
            bisWrap.removeAttribute('hidden');
          } else {
            bisWrap.setAttribute('hidden', '');
          }
        }
      }

      function onOptionChange() {
        var v = findVariant(product, currentSelections());
        applyVariant(v);
      }

      optionEls.forEach(function (el) {
        el.addEventListener('change', onOptionChange);
      });
    }

    document.querySelectorAll('.kk-product-thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-url');
        var alt = btn.getAttribute('data-alt') || '';
        var wrap = document.getElementById('kk-product-main-wrap');
        if (!wrap || !url) return;
        var img = document.getElementById('kk-product-main-img');
        if (!img) {
          wrap.innerHTML =
            '<img id="kk-product-main-img" src="" alt="" width="1400" height="1400" loading="lazy">';
          img = document.getElementById('kk-product-main-img');
        }
        img.src = url;
        img.alt = alt;
        document.querySelectorAll('.kk-product-thumb').forEach(function (t) {
          t.classList.remove('is-active');
        });
        btn.classList.add('is-active');
      });
    });

    var submitBtn = document.getElementById('kk-product-submit');
    if (submitBtn && cartDrawerEnabled) {
      productForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var fd = new FormData(productForm);
        fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            if (data.status === 422) {
              showToast(
                data.description || data.message || kkStr('toastAddError', 'Could not add to cart')
              );
              return;
            }
            if (data.errors) {
              showToast(
                typeof data.errors === 'string' ? data.errors : kkStr('toastAddError', 'Could not add to cart')
              );
              return;
            }
            showToast(kkStr('toastAdded', 'Added to bag'));
            return refreshCartUi().then(function () {
              if (cartDrawer) {
                loadCartDrawer().then(function () {
                  openDrawer(cartDrawer);
                });
              }
            });
          })
          .catch(function () {
            productForm.submit();
          });
      });
    }

    var stickyAdd = document.querySelector('.js-kk-sticky-add');
    if (stickyAdd && productForm) {
      stickyAdd.addEventListener('click', function () {
        if (productForm.requestSubmit) {
          productForm.requestSubmit();
        } else {
          productForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      });
    }

    if (submitBtn) {
      var sticky = document.getElementById('kk-atc-sticky');
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!sticky) return;
            if (entry.isIntersecting) {
              sticky.setAttribute('hidden', '');
            } else {
              sticky.removeAttribute('hidden');
            }
          });
        },
        { rootMargin: '0px', threshold: 0.15 }
      );
      io.observe(submitBtn);
    }
  }

  /* Back to top */
  var back = document.querySelector('.js-kk-back-top');
  if (back) {
    window.addEventListener(
      'scroll',
      function () {
        if (window.scrollY > 500) {
          back.removeAttribute('hidden');
        } else {
          back.setAttribute('hidden', '');
        }
      },
      { passive: true }
    );
    back.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* First cart badge sync (optional) */
  refreshCartUi();
})();

/* =============================================================
   ENHANCEMENTS v2
   ============================================================= */
(function () {
  'use strict';

  /* ----------------------------------------------------------
     Page loading progress bar
  ---------------------------------------------------------- */
  var bar = document.createElement('div');
  bar.className = 'kk-progress';
  document.body.appendChild(bar);
  var barTimer;

  function barStart() {
    clearTimeout(barTimer);
    bar.style.width = '0';
    bar.classList.remove('is-done');
    bar.style.transition = 'none';
    requestAnimationFrame(function () {
      bar.style.transition = 'width 6s cubic-bezier(.1,.9,.2,1)';
      bar.style.width = '85%';
    });
  }
  function barDone() {
    bar.style.transition = 'width .2s ease';
    bar.style.width = '100%';
    barTimer = setTimeout(function () { bar.classList.add('is-done'); }, 600);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a');
    if (!a || !a.href || a.target === '_blank' || a.href.startsWith('#') || a.href.startsWith('mailto:') || a.href.startsWith('tel:') || e.metaKey || e.ctrlKey || e.shiftKey) return;
    if (new URL(a.href).hostname !== window.location.hostname) return;
    barStart();
  });
  window.addEventListener('pageshow', barDone);

  /* ----------------------------------------------------------
     Scroll-reveal: fade elements with .kk-reveal into view
  ---------------------------------------------------------- */
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.kk-reveal').forEach(function (el) {
      revealObserver.observe(el);
    });
  } else {
    document.querySelectorAll('.kk-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  /* ----------------------------------------------------------
     Image lightbox for product gallery
  ---------------------------------------------------------- */
  var lightbox = document.getElementById('kk-lightbox');
  var lightboxImg = document.getElementById('kk-lightbox-img');

  function openLightbox(src, alt) {
    if (!lightbox || !lightboxImg) return;
    lightboxImg.src = src;
    lightboxImg.alt = alt || '';
    lightbox.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.setAttribute('hidden', '');
    document.documentElement.style.overflow = '';
    if (lightboxImg) lightboxImg.src = '';
  }

  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox || e.target.classList.contains('js-kk-lightbox-close')) {
        closeLightbox();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lightbox.hasAttribute('hidden')) closeLightbox();
    });
  }

  document.querySelectorAll('.js-kk-zoom-img').forEach(function (img) {
    img.addEventListener('click', function () {
      openLightbox(img.src, img.alt);
    });
  });

  // Also allow clicking the main product image after thumb swaps
  document.addEventListener('click', function (e) {
    var img = e.target.closest('#kk-product-main-img');
    if (img) openLightbox(img.src, img.alt);
  });

  /* ----------------------------------------------------------
     Share button (Web Share API + clipboard fallback)
  ---------------------------------------------------------- */
  document.querySelectorAll('.js-kk-share').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url   = btn.getAttribute('data-url');
      var title = btn.getAttribute('data-title') || document.title;
      var text  = btn.getAttribute('data-text') || '';
      var label = btn.querySelector('span');
      var copied = (window.kkStrings && window.kkStrings.productShareCopied) || 'Link copied!';

      if (navigator.share) {
        navigator.share({ title: title, text: text, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          if (label) {
            var orig = label.textContent;
            label.textContent = copied;
            setTimeout(function () { label.textContent = orig; }, 2200);
          }
        }).catch(function () {});
      } else {
        var ta = document.createElement('textarea');
        ta.value = url;
        ta.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0;';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(ta);
        if (label) {
          var orig2 = label.textContent;
          label.textContent = copied;
          setTimeout(function () { label.textContent = orig2; }, 2200);
        }
      }
    });
  });

  /* ----------------------------------------------------------
     Recently viewed products (localStorage)
  ---------------------------------------------------------- */
  var rvEl     = document.querySelector('.js-kk-recently-viewed');
  var rvGrid   = document.querySelector('.js-kk-rv-grid');
  var rvDataEl = document.getElementById('kk-rv-current');
  var RV_KEY   = 'kkRecentlyViewed';
  var RV_MAX   = 8;

  function rvLoad() {
    try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { return []; }
  }
  function rvSave(items) {
    try { localStorage.setItem(RV_KEY, JSON.stringify(items)); } catch (e) {}
  }

  if (rvDataEl) {
    var current;
    try { current = JSON.parse(rvDataEl.textContent); } catch (e) { current = null; }
    if (current && current.handle) {
      var list = rvLoad();
      list = list.filter(function (p) { return p.handle !== current.handle; });
      list.unshift(current);
      if (list.length > RV_MAX) list = list.slice(0, RV_MAX);
      rvSave(list);
    }
  }

  if (rvEl && rvGrid) {
    var rvItems = rvLoad();
    var currentHandle = rvDataEl ? (function () { try { return JSON.parse(rvDataEl.textContent).handle; } catch (e) { return null; } }()) : null;
    rvItems = rvItems.filter(function (p) { return p.handle !== currentHandle; }).slice(0, 4);

    if (rvItems.length > 0) {
      var fmt = window.kkMoneyFormat || '{{amount}}';
      function fmtMoney(cents) {
        var n = typeof cents === 'number' ? cents : parseInt(cents, 10) || 0;
        var amount = (n / 100).toFixed(2);
        if (/\{\{\s*amount_no_decimals/.test(fmt)) return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(n / 100)));
        return fmt.replace(/\{\{\s*amount\s*\}\}/g, amount);
      }

      rvGrid.innerHTML = rvItems.map(function (p) {
        var img = p.image
          ? '<img src="' + p.image + '" alt="" class="kk-product-image" loading="lazy" width="400" height="400">'
          : '<div class="kk-product-placeholder" style="margin:0;">🧶</div>';
        return (
          '<article class="kk-product kk-reveal">' +
          '<a href="' + p.url + '" class="kk-product-image-wrap">' + img + '</a>' +
          '<h3><a href="' + p.url + '">' + p.title + '</a></h3>' +
          '<p class="kk-price">' + fmtMoney(p.price) + '</p>' +
          '<a href="' + p.url + '" class="kk-card-link">View product</a>' +
          '</article>'
        );
      }).join('');

      rvEl.removeAttribute('hidden');

      if ('IntersectionObserver' in window) {
        rvGrid.querySelectorAll('.kk-reveal').forEach(function (el) {
          revealObserver.observe(el);
        });
      } else {
        rvGrid.querySelectorAll('.kk-reveal').forEach(function (el) {
          el.classList.add('is-visible');
        });
      }
    }
  }

  /* ----------------------------------------------------------
     Expose productShareCopied string to kkStrings
  ---------------------------------------------------------- */
  if (window.kkStrings) {
    var s = window.kkStrings;
    if (!s.productShareCopied) s.productShareCopied = 'Link copied!';
  }

}());

/* =============================================================
   FEATURES v3 — newsletter popup, back-in-stock, custom order
   ============================================================= */
(function () {
  'use strict';

  /* ----------------------------------------------------------
     Newsletter popup
  ---------------------------------------------------------- */
  var popup     = document.getElementById('kk-popup');
  var STORE_KEY = 'kkPopupDismissed';

  function closePopup() {
    if (!popup) return;
    localStorage.setItem(STORE_KEY, '1');
    popup.setAttribute('hidden', '');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function openPopup() {
    if (!popup) return;
    if (localStorage.getItem(STORE_KEY)) return;
    popup.removeAttribute('hidden');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var firstInput = popup.querySelector('input[type="email"]');
    if (firstInput) setTimeout(function () { firstInput.focus(); }, 50);
  }

  if (popup) {
    var delay      = parseInt(popup.dataset.delay || '10000', 10);
    var exitIntent = popup.dataset.exit === 'true';

    if (!localStorage.getItem(STORE_KEY)) {
      setTimeout(openPopup, delay);

      if (exitIntent) {
        document.documentElement.addEventListener('mouseleave', function handler(e) {
          if (e.clientY < 10) {
            openPopup();
            document.documentElement.removeEventListener('mouseleave', handler);
          }
        });
      }
    }

    /* Dismiss triggers */
    popup.querySelectorAll('.js-kk-popup-dismiss').forEach(function (el) {
      el.addEventListener('click', closePopup);
    });
    popup.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePopup();
    });

    /* Form submission via fetch — show success inline */
    var form         = popup.querySelector('.js-kk-popup-form');
    var formState    = popup.querySelector('.js-kk-popup-form-state');
    var successState = popup.querySelector('.js-kk-popup-success-state');

    if (form && formState && successState) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var fd = new FormData(form);
        fetch(form.action || window.location.pathname, {
          method: 'POST',
          body: fd,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        }).then(function () {
          showPopupSuccess();
        }).catch(function () {
          showPopupSuccess();
        });
        localStorage.setItem(STORE_KEY, '1');
      });
    }

    function showPopupSuccess() {
      if (!formState || !successState) return;
      formState.setAttribute('hidden', '');
      successState.removeAttribute('hidden');
    }

    /* Copy discount code */
    var copyBtn = popup.querySelector('.js-kk-popup-copy-code');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var codeEl = popup.querySelector('.js-kk-popup-code');
        if (!codeEl) return;
        var code = codeEl.textContent.trim();
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).then(function () {
            var lbl = copyBtn.querySelector('.js-kk-copy-label');
            if (lbl) { lbl.textContent = 'Copied!'; setTimeout(function () { lbl.textContent = 'Copy'; }, 2000); }
          });
        }
      });
    }
  }

  /* ----------------------------------------------------------
     Back-in-stock form — AJAX submit
  ---------------------------------------------------------- */
  var bisForm = document.querySelector('.js-kk-bis-form');
  if (bisForm) {
    bisForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = bisForm.querySelector('input[type="email"]');
      if (!email || !email.value) return;
      var fd = new FormData(bisForm);
      fetch(bisForm.action || window.location.pathname, {
        method: 'POST',
        body: fd,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function () {
        var ok = bisForm.querySelector('.js-kk-bis-success');
        if (ok) {
          ok.removeAttribute('hidden');
          bisForm.querySelector('.kk-bis-row').setAttribute('hidden', '');
          var note = bisForm.querySelector('.kk-bis-note');
          if (note) note.setAttribute('hidden', '');
        }
      }).catch(function () {});
    });
  }

  /* ----------------------------------------------------------
     Custom order form — file drop zone UI
  ---------------------------------------------------------- */
  var fileDrop  = document.getElementById('kk-file-drop');
  var fileInput = document.querySelector('.js-kk-file-input');
  var fileLabel = document.querySelector('.js-kk-file-label');

  if (fileDrop && fileInput && fileLabel) {
    fileInput.addEventListener('change', function () {
      var f = fileInput.files[0];
      if (f) {
        fileDrop.classList.add('has-file');
        fileLabel.innerHTML = '<span>📎 ' + f.name + '</span>';
      }
    });

    fileDrop.addEventListener('dragover', function (e) {
      e.preventDefault();
      fileDrop.classList.add('is-drag-over');
    });
    fileDrop.addEventListener('dragleave', function () {
      fileDrop.classList.remove('is-drag-over');
    });
    fileDrop.addEventListener('drop', function (e) {
      e.preventDefault();
      fileDrop.classList.remove('is-drag-over');
      if (e.dataTransfer && e.dataTransfer.files.length) {
        fileInput.files = e.dataTransfer.files;
        var f = fileInput.files[0];
        if (f) {
          fileDrop.classList.add('has-file');
          fileLabel.innerHTML = '<span>📎 ' + f.name + '</span>';
        }
      }
    });
  }

}());
